export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      icon: 'ri-phone-line',
      title: 'Contact Us',
      description: 'Call (915) 206-5814 or fill out our contact form. Tell us about your tenant occupied property—location, size, number of units, tenant situation, and any relevant details.'
    },
    {
      number: '02',
      title: 'Property Evaluation',
      description: 'We review your property details, current leases, rent rolls, and tenant information. We may schedule a brief inspection that minimizes disruption to your tenants.',
      icon: 'ri-file-list-3-fill'
    },
    {
      number: '03',
      title: 'Cash Offer Presented',
      description: 'Within 24-48 hours, we present a competitive all-cash offer. No obligations, no pressure. Take time to review and ask questions about the process.',
      icon: 'ri-hand-coin-fill'
    },
    {
      number: '04',
      title: 'Accept & Schedule Closing',
      description: 'If you accept our offer, we immediately schedule closing with our title company. Choose a closing date that works for your timeline—as soon as 7 days or longer if needed.',
      icon: 'ri-calendar-check-fill'
    },
    {
      number: '05',
      title: 'Title Company Processing',
      description: 'Our title company handles all paperwork, lease transfers, tenant notifications, and legal compliance. They ensure everything is done correctly and all parties are protected.',
      icon: 'ri-shield-check-fill'
    },
    {
      number: '06',
      title: 'Close & Get Paid',
      description: 'Sign the final documents at the title company office. Receive your payment immediately—typically via wire transfer or cashier\'s check. Your tenants stay in place.',
      icon: 'ri-money-dollar-circle-fill'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Simple Process to Buy Rental Property
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Selling tenant occupied real estate is straightforward when you work with experienced buyers. Here's our proven 6-step process from first contact to closing.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="absolute -top-4 -left-4 w-16 h-16 bg-teal-600 text-white rounded-lg flex items-center justify-center text-2xl font-bold shadow-lg">
                {step.number}
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6 ml-auto">
                <i className={`${step.icon} text-teal-600 text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="relative">
          <img 
            src="https://public.readdy.ai/ai/img_res/fd856ef5f375bd5f3e384ec972cdcbe5.jpg"
            alt="Tenant Occupied Property Closing Process"
            className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent rounded-2xl flex items-center">
            <div className="max-w-xl p-12 text-white">
              <h3 className="text-3xl font-bold mb-4">Fast, Professional, Secure</h3>
              <p className="text-lg text-white/90 mb-6">
                Our streamlined process typically takes 7-14 days from offer acceptance to closing. Every transaction is handled through a reputable title company, ensuring complete legal protection and peace of mind.
              </p>
              <a 
                href="#contact"
                className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-bold transition-all cursor-pointer whitespace-nowrap"
              >
                Start Your Sale Today
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}